'use client';

export default function Footer() {
    return (
        <footer className="flex h-10 items-center justify-between gap-3 border-t-[0.5px] border-line bg-white px-4 text-xs text-muted sm:px-6">
            <div className="min-w-0 truncate">Everything runs fully client-side</div>
            <div className="flex shrink-0 items-center gap-1.5 rounded-full bg-subtle px-2 py-0.5 text-[11px] text-ink">
                <span>🔒</span>
                <span className="whitespace-nowrap">No data collected</span>
            </div>
        </footer>
    );
}
